import { render, staticRenderFns } from "./serviceType.vue?vue&type=template&id=6a5eb079&scoped=true&"
import script from "./serviceType.vue?vue&type=script&lang=js&"
export * from "./serviceType.vue?vue&type=script&lang=js&"
import style0 from "./serviceType.vue?vue&type=style&index=0&id=6a5eb079&lang=scss&scoped=true&"
import style1 from "./serviceType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5eb079",
  null
  
)

component.options.__file = "serviceType.vue"
export default component.exports